import { render, staticRenderFns } from "./MypageMailChangeCompleteSection.vue?vue&type=template&id=93ff1ffc&scoped=true"
import script from "./MypageMailChangeCompleteSection.vue?vue&type=script&lang=ts"
export * from "./MypageMailChangeCompleteSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageMailChangeCompleteSection.vue?vue&type=style&index=0&id=93ff1ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ff1ffc",
  null
  
)

export default component.exports